export enum ClientType {
  LOGISTICS = 'LOGISTICS',
  ON_DEMAND = 'ON_DEMAND'
}
